// Quick fix for Leaflet map errors
// Add this to your main App.js or index.js

// Error boundary for Leaflet map components
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('_leaflet_pos')) {
    console.warn('Leaflet positioning error caught and handled:', event.error);
    event.preventDefault();
    return false;
  }
});

// Ensure Leaflet map containers are properly initialized
if (typeof window !== 'undefined' && window.L) {
  const originalMap = window.L.Map;
  window.L.Map = function(element, options) {
    if (element && typeof element === 'string') {
      element = document.getElementById(element);
    }
    if (!element) {
      console.warn('Map container element not found, creating placeholder');
      element = document.createElement('div');
      element.style.height = '400px';
      element.style.width = '100%';
    }
    return new originalMap(element, options);
  };
}

export default null;